const bootstrapSettings = {
  layout: {trashHold: "lg"},
  navbar: {collapseOnClick: true},
};

const dataSettings = {
  genders: [
    { value: "M", name: "M", code: "genderM" },
    { value: "F", name: "F", code: "genderF" },
    { value: "N", name: "N", code: "genderN" },
  ],
};

export default { dataSettings, bootstrapSettings };
